import React from "react";
const icon = (
  <svg
    width="640"
    height="512"
    viewBox="0 0 640 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 64C49.7 64 64 78.3 64 96V416C64 433.7 49.7 448 32 448C14.3 448 0 433.7 0 416V96C0 78.3 14.3 64 32 64ZM246.6 137.4C259.1 149.9 259.1 170.2 246.6 182.7L205.3 224H434.8L393.4 182.6C380.9 170.1 380.9 149.8 393.4 137.3C405.9 124.8 426.2 124.8 438.7 137.3L534.7 233.3C547.2 245.8 547.2 266.1 534.7 278.6L438.7 374.6C426.2 387.1 405.9 387.1 393.4 374.6C380.9 362.1 380.9 341.8 393.4 329.3L434.7 288H205.2L246.6 329.4C259.1 341.9 259.1 362.2 246.6 374.7C234.1 387.2 213.8 387.2 201.3 374.7L105.3 278.7C92.8 266.2 92.8 245.9 105.3 233.4L201.3 137.4C213.8 124.9 234.1 124.9 246.6 137.4ZM640 96V416C640 433.7 625.7 448 608 448C590.3 448 576 433.7 576 416V96C576 78.3 590.3 64 608 64C625.7 64 640 78.3 640 96Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
